import angular from 'angular';
import UpdateTitle from './update-title.directive';

export default angular
  .module('accountsApp.update-title', [])
  .directive('updateTitle', UpdateTitle)
  .name;



// WEBPACK FOOTER //
// ./client/components/update-title/index.js